module.exports = __webpack_public_path__ + "static/img/MvpBg.927fc3f3.png";